export enum StoreKeys {
	app = 'app',
	formTemplate = 'formTemplate',
}
